import { render } from "./ClasElem_Tarifario.vue?vue&type=template&id=984bc438"
import script from "./ClasElem_Tarifario.vue?vue&type=script&lang=js"
export * from "./ClasElem_Tarifario.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__